import { CoStar } from "@costar-gen/pds-node-client";
import { SortOrder } from "@costar-search-x/core";
import { ValueOf } from "@costar-suite/core";

export const SortDirection = CoStar.Api.Professional.SortDirection;

export const sortOrderToDirection = (
  sortOrder: ValueOf<typeof SortOrder> | undefined
) => {
  switch (sortOrder) {
    case SortOrder.Ascending:
      return SortDirection.Ascending;
    case SortOrder.Descending:
      return SortDirection.Descending;
  }
  return undefined;
};

export const sortDirectionToOrder = (sortDireciton: number | undefined) => {
  switch (sortDireciton) {
    case SortDirection.Ascending:
      return SortOrder.Ascending;
    case SortDirection.Descending:
      return SortOrder.Descending;
  }
  return undefined;
};
